import { useMemo } from 'react';

import { Dayjs, getDateInLocalTimezone, newDate } from '~/services/TimeService';

function useLocalizedDatePeriod(period: { from: string; to: string }) {
  const local = useMemo(
    () => ({
      from: getDateInLocalTimezone(period.from),
      to: getDateInLocalTimezone(period.to),
    }),
    [period.from, period.to],
  );

  const range: [Dayjs | null, Dayjs | null] = useMemo(
    () => [local.from ? newDate(local.from) : null, local.to ? newDate(local.to) : null],
    [local.from, local.to],
  );

  return { local, range };
}

export default useLocalizedDatePeriod;
